import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import LandingHome from "@/pages/LandingHome";
import WebinarLanding from "@/pages/WebinarLanding";
import MesterkurzusLanding from "@/pages/MesterkurzusLanding";
import WebinarThankYou from "@/pages/WebinarThankYou";
import KoszonjukPage from "@/pages/KoszonjukPage";
import SprintRedirect from "@/pages/SprintRedirect";
import LegalAszf from "@/pages/LegalAszf";
import LegalAdatkezelesi from "@/pages/LegalAdatkezelesi";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Agents from "@/pages/Agents";
import BrandVoice from "@/pages/BrandVoice";
import AvatarCraft from "@/pages/AvatarCraft";
import OfferCraft from "@/pages/OfferCraft";
import ComingSoon from "@/pages/ComingSoon";
import AssetVault from "@/pages/AssetVault";
import Identity from "@/pages/Identity";
import AdminDashboard from "@/pages/AdminDashboard";
import PrintBlueprint from "@/pages/PrintBlueprint";
import PrintLeadMagnet from "@/pages/PrintLeadMagnet";
import {
  MagnetPostAgent,
  EmailAgent,
  LeadMagnetAgent,
} from "@/pages/AttractionAgents";
import {
  WebinarAgent,
  LandingAgent,
  SalesAgent,
} from "@/pages/ConversionAgents";
import SalesCallClosing from "@/pages/SalesCallClosing";

function Router() {
  const location = useLocation();

  // Synchronous check prevents race conditions with session_id in URL fragment
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      {/* PUBLIC landing — Layout-on KÍVÜL (sidebar/header chrome nélkül).
          A /login URL ugyanezt a komponenst tölti be, hogy egységes prémium
          belépési élményt kapjon a user (LoginModal a landing fölött). */}
      <Route path="/" element={<LandingHome />} />
      <Route path="/login" element={<LandingHome />} />

      {/* Webinar landing — KÜLÖN duplikált oldal, az eredeti `/` ÉRINTETLEN. */}
      <Route path="/webinar" element={<WebinarLanding />} />
      <Route path="/mesterkurzus" element={<MesterkurzusLanding />} />
      <Route path="/webinar-thankyou" element={<WebinarThankYou />} />
      <Route path="/koszonjuk" element={<KoszonjukPage />} />

      {/* Sprint checkout redirect (mexmagic.hu/sprint → Circle checkout). */}
      <Route path="/sprint" element={<SprintRedirect />} />
      {/* Public legal pages — accessible without auth, no redirect to /dashboard */}
      <Route path="/aszf" element={<LegalAszf />} />
      <Route path="/adatkezelesi-tajekoztato" element={<LegalAdatkezelesi />} />

      {/* Print routes — Layout-on KÍVÜL, semmi sidebar/header chrome.
          A Playwright headless böngésző ezt a route-ot tölti be a
          PDF-generáláshoz. */}
      <Route path="/print/blueprint/:type" element={<PrintBlueprint />} />
      <Route path="/print/lead-magnet" element={<PrintLeadMagnet />} />

      <Route element={<Layout />}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/agents" element={<Agents />} />
        <Route path="/agents/voice" element={<BrandVoice />} />
        <Route path="/agents/client" element={<AvatarCraft />} />
        <Route path="/agents/offer" element={<OfferCraft />} />

        {/* Vonzás agents — opening screens only, generation TBD */}
        <Route path="/agents/magnet-post" element={<MagnetPostAgent />} />
        <Route path="/agents/email" element={<EmailAgent />} />
        <Route path="/agents/lead-magnet" element={<LeadMagnetAgent />} />

        {/* Értékesítés agents — opening screens only, generation TBD */}
        <Route path="/agents/webinar" element={<WebinarAgent />} />
        <Route path="/agents/landing" element={<LandingAgent />} />
        <Route path="/agents/sales" element={<SalesAgent />} />
        <Route path="/agents/sales-call-closing" element={<SalesCallClosing />} />
        <Route
          path="/identity"
          element={<Identity />}
        />
        <Route
          path="/asset-vault"
          element={<AssetVault />}
        />
        <Route
          path="/recordings"
          element={<ComingSoon title="Felvételek" subtitle="Webinar-, sales call- és brainstorm-felvételek." />}
        />
        {/* ADMIN — role-védve a komponensen belül */}
        <Route path="/admin" element={<AdminDashboard />} />
      </Route>

      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Router />
          <Toaster
            theme="dark"
            position="top-right"
            toastOptions={{
              style: {
                background: "#141414",
                border: "1px solid rgba(255,255,255,0.08)",
                color: "#fff",
              },
            }}
          />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
